var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoReloadG(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lc6kviaqta"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 130",
    style: {
      fill: "#a8a8a8"
    },
    d: "M0 0h20v15.156H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 306"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 131",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 129"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 127",
    style: {
      clipPath: "url(#lc6kviaqta)"
    },
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 102",
    d: "M12.906 17.954a.979.979 0 0 0-1.006-.244 5.161 5.161 0 0 1-.706.189 6.338 6.338 0 0 1-1.18.107A5.291 5.291 0 0 1 6.1 16.375a5.289 5.289 0 0 1-1.63-3.912v-.2l.789.789a.985.985 0 0 0 1.362 0 .965.965 0 0 0 0-1.362L4.132 9.2a.964.964 0 0 0-1.362 0L.282 11.691a.965.965 0 0 0 0 1.362.985.985 0 0 0 1.362 0l.79-.789v.2A7.318 7.318 0 0 0 4.671 17.8a7.322 7.322 0 0 0 5.341 2.237 7.768 7.768 0 0 0 1.762-.2 6.249 6.249 0 0 0 .825-.254.979.979 0 0 0 .612-.713.954.954 0 0 0-.261-.87z",
    transform: "translate(0 -4.885)",
    style: {
      fill: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 103",
    d: "M27.913 6.942a.986.986 0 0 0-1.362 0l-.789.789v-.153a7.321 7.321 0 0 0-2.237-5.341A7.32 7.32 0 0 0 18.184 0a8.244 8.244 0 0 0-1.758.189 6.037 6.037 0 0 0-.819.243.981.981 0 0 0-.618.712.953.953 0 0 0 .26.88l.08.079a.952.952 0 0 0 .955.234c.231-.069.476-.131.727-.184a5.7 5.7 0 0 1 1.174-.117A5.291 5.291 0 0 1 22.1 3.667a5.292 5.292 0 0 1 1.631 3.911v.108l-.766-.767a.973.973 0 0 0-1.385.023.963.963 0 0 0 0 1.362l2.488 2.488a.963.963 0 0 0 1.363 0L27.913 8.3a.963.963 0 0 0 0-1.362",
    transform: "translate(-8.195)",
    style: {
      fill: "#a8a8a8"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoReloadG);
export default __webpack_public_path__ + "static/media/ico-reload-g.d7dcb155957d3a5a85817ba13e144243.svg";
export { ForwardRef as ReactComponent };